function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { MotionBox } from '@tapresearch/ui/components';
export function OpacityTransitionBox(_param) {
    var _param_finalOpacity = _param.finalOpacity, finalOpacity = _param_finalOpacity === void 0 ? 1 : _param_finalOpacity, _param_duration = _param.duration, duration = _param_duration === void 0 ? 1 : _param_duration, rest = _object_without_properties(_param, [
        "finalOpacity",
        "duration"
    ]);
    return /*#__PURE__*/ React.createElement(MotionBox, _object_spread({
        initial: {
            opacity: 0
        },
        animate: {
            opacity: finalOpacity
        },
        transition: {
            opacity: {
                type: 'tween',
                default: {
                    duration: duration
                }
            }
        },
        exit: {
            opacity: 0
        }
    }, rest));
}
